<div *ngIf="currentUser" class="px-4 py-2 md:px-8 md:py-4">
  <div *ngIf="currentMemberCourse?.status === 'paid'"
    class="w-full">
    <div *ngIf="memberProgress$ | async" 
      class="flex flex-col lg:flex-row lg:justify-around lg:items-start gap-4 lg:gap-6">
      
      <!-- Progress Charts Section -->
      <div class="w-full lg:w-2/5 flex flex-col gap-4">
        <!-- Progress Chart Card -->
        <mat-card class="w-full">
          <mat-card-header>
            <mat-card-title class="text-lg md:text-xl">Your progress</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-4">
            <div class="w-full">
              <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" 
                class="w-full block">
              </highcharts-chart>
            </div>
          </mat-card-content>
          <mat-card-actions class="flex flex-col sm:flex-row justify-center items-center gap-2 px-4 pb-4">
            <button mat-raised-button color="primary" (click)="gotoCourseView()" 
              class="w-full sm:w-auto">
              Continue Course
            </button>
            <button mat-raised-button color="primary" (click)="downloadCertificate()" 
              [disabled]="!completedFinal" class="w-full sm:w-auto">
              Print Certificate
            </button>
          </mat-card-actions>
        </mat-card>

        <!-- Average Score Chart Card -->
        <mat-card class="w-full">
          <mat-card-header>
            <mat-card-title class="text-lg md:text-xl">Average Quiz Score</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-4">
            <div class="w-full">
              <highcharts-chart [Highcharts]="highcharts" [options]="scoreChartOptions"
                class="w-full block">
              </highcharts-chart>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Progress Table Card -->
      <div class="w-full lg:w-3/5">
        <mat-card class="w-full">
          <mat-card-header>
            <mat-card-title class="text-lg md:text-xl">
              Course Progress for {{ currentUser.fname }} {{ currentUser.lname }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-4">
            <div class="overflow-x-auto -mx-4 md:mx-0">
              <table mat-table [dataSource]="memberProgress$" class="w-full mobile-table">

                <ng-container matColumnDef="Location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="mobile-table-header" style="max-width: 120px;"> 
                    <span class="text-xs md:text-sm font-semibold">Location</span>
                  </th>
                  <td mat-cell *matCellDef="let element" class="mobile-table-cell" style="max-width: 120px;"> 
                    <span class="text-xs md:text-sm font-medium">
                      {{element.quiz && element.quiz.QuizLocation}} - Quiz
                      {{element.quiz && element.quiz.QuizOrder}}
                      of
                      {{element.quiz && element.quiz.QuizLocation2}}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="QuizTitle">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="mobile-table-header" style="max-width: 150px;"> 
                    <span class="text-xs md:text-sm font-semibold">Quiz</span>
                  </th>
                  <td mat-cell *matCellDef="let element" class="mobile-table-cell" style="max-width: 150px;"> 
                    <span class="text-xs md:text-sm text-gray-700 line-clamp-2">
                      {{element.quiz && element.quiz.QuizTitle}} 
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Score">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="mobile-table-header text-right" style="min-width: 70px;"> 
                    <span class="text-xs md:text-sm font-semibold whitespace-nowrap">High Score</span>
                  </th>
                  <td mat-cell *matCellDef="let element" class="mobile-table-cell text-right" style="min-width: 70px;"> 
                    <span class="text-xs md:text-sm font-semibold text-blue-600">
                      {{element.quiz && element.Score}}%
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Attempts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="mobile-table-header text-right" style="min-width: 70px;"> 
                    <span class="text-xs md:text-sm font-semibold whitespace-nowrap">Attempts</span>
                  </th>
                  <td mat-cell *matCellDef="let element" class="mobile-table-cell text-right" style="min-width: 70px;"> 
                    <span class="text-xs md:text-sm text-gray-600">
                      {{element.quiz && element.attempts }} 
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="DTStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="mobile-table-header hidden md:table-cell"> 
                    <span class="text-xs md:text-sm font-semibold">Last Date</span>
                  </th>
                  <td mat-cell *matCellDef="let element" class="mobile-table-cell hidden md:table-cell"> 
                    <span class="text-xs md:text-sm text-gray-500">
                      {{ element.quiz && getLocalDate(element.DTStamp) }} 
                    </span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mobile-table-header-row"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mobile-table-row"></tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
